import { IDocumentoSetorialPagedResponse } from "models/response/documento-setorial-paged-response";

export interface DocumentoSetorialDetailsState {
  documentoSetorialDetails: IDocumentoSetorialPagedResponse | null;
  loading: boolean;
  error: string | null;
}

export const ACTION_TYPES = {
  setDocumentoSetorialDetails: 'setDocumentoSetorialDetails',
  setLoading: 'setLoading',
  setError: 'setError',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface DocumentoSetorialDetailsAction {
  type: ActionType;
  payload: any;
}

export const DocumentoSetorialDetailsReducer = (
  state: DocumentoSetorialDetailsState,
  action: DocumentoSetorialDetailsAction
): DocumentoSetorialDetailsState => {
  switch (action.type) {
    case ACTION_TYPES.setDocumentoSetorialDetails:
      return { ...state, documentoSetorialDetails: action.payload, error: null };
    case ACTION_TYPES.setLoading:
      return { ...state, loading: action.payload };
    case ACTION_TYPES.setError:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};
